"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerComunicado = void 0;
var React = require("react");
var FetchAnuncios_1 = require("./FetchAnuncios");
var reactstrap_1 = require("reactstrap");
//import imgAnuncio from "./img-anuncio.JPG";
var url_js_1 = require("../variables/url.js");
var espolAds_1 = require("../variables/espolAds");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var unidad = localBack + 'api/Catalog/Unidad';
var categoria = localBack + 'api/Catalog/Categorias';
var audiencia = localBack + 'api/Catalog/Audiencia';
var anuncio = localBack + 'api/Catalog/Anuncios/';
var areas = localBack + 'api/Catalog/Area';
var VerComunicado = /** @class */ (function (_super) {
    __extends(VerComunicado, _super);
    function VerComunicado(props) {
        var _this = _super.call(this, props) || this;
        _this.toTop = function () {
            var elem = document.getElementById("scroller");
            elem.scrollIntoView();
        };
        _this.state = {
            title: "", loading: true, dtoData: new FetchAnuncios_1.AnunciosData, unidadList: [],
            categoriaList: [], audienciaList: [], areas: [], status: 0
        };
        fetch(unidad)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ unidadList: data });
        });
        fetch(categoria)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ categoriaList: data });
        });
        fetch(audiencia)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ audienciaList: data });
        });
        fetch(areas)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ areas: data });
        });
        var dtoid = _this.props.match.params["id"];
        // This will set state for Edit employee  
        if (dtoid > 0) {
            fetch(anuncio + dtoid, {
                method: 'GET',
                headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
            })
                .then(function (response) {
                _this.setState({ status: response.status });
                return response.json();
            })
                .then(function (data) {
                _this.setState({ title: "Edit", loading: false, dtoData: data });
            });
        }
        return _this;
        // This will set state for Add employee  
        // This binding is necessary to make "this" work in the callback  
    }
    VerComunicado.prototype.handleHistory = function (id) {
        this.props.history.push("/ver-historial/" + id);
    };
    VerComunicado.prototype.handleEdit = function (id) {
        if (this.state.dtoData.bdEstado != 'Z') {
            this.props.history.push("/creator/anuncios/edit/" + id);
            /*console.log(id);*/
        }
        else {
            alert("Solo puede editarse un comunicado en estado Rechazado.\n");
        }
    };
    VerComunicado.prototype.end = function () {
        espolAds_1.expiro();
        this.props.history.push('/general/principal');
    };
    VerComunicado.prototype.render = function () {
        var contents = (this.state.status == 0)
            ? React.createElement("div", null,
                React.createElement("h5", { className: "title" }, "Loading...."),
                React.createElement("div", { className: "loader" }))
            : (this.state.status != 200 && this.state.status != 201) ? this.end()
                : this.renderComunicado(this.state.unidadList, this.state.categoriaList, this.state.audienciaList);
        return React.createElement("div", null,
            React.createElement("div", { id: "top" }),
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, "COMUNICADO")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    // Returns the HTML Form to the render() method.  
    VerComunicado.prototype.renderComunicado = function (unidadList, categoriaList, audienciaList) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardBody, { className: "main-content mb-12" },
                            React.createElement("div", null,
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { sm: "6" },
                                        React.createElement(reactstrap_1.Card, { key: this.state.dtoData.idAnuncio, body: true },
                                            React.createElement("a", { href: this.state.dtoData.txImagen, target: "_blank" },
                                                React.createElement("img", { src: this.state.dtoData.txImagen, alt: "anuncio", className: "img-fluid" })),
                                            React.createElement("br", null),
                                            React.createElement(reactstrap_1.CardBody, null,
                                                React.createElement("h5", { className: "titulo-anuncio" }, "Descripci\u00F3n: "),
                                                React.createElement(reactstrap_1.CardText, null,
                                                    React.createElement("div", { className: "form-group row mb-10" },
                                                        React.createElement("p", null,
                                                            React.createElement("strong", { className: "valor" }, this.state.dtoData.txTexto))))))),
                                    React.createElement(reactstrap_1.Col, { sm: "6" },
                                        React.createElement(reactstrap_1.Card, { key: this.state.dtoData.idAnuncio, body: true },
                                            React.createElement("br", null),
                                            React.createElement("h5", null, this.state.dtoData.txTitulo),
                                            React.createElement(reactstrap_1.CardText, null,
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Tipo:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.bdTipo == "E" ? "Evento" : "Anuncio")),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "\u00C1rea:"),
                                                    this.state.areas.map(function (area) {
                                                        return area.idArea == _this.state.dtoData.idArea
                                                            ? React.createElement("strong", { className: "valor" },
                                                                "\u00A0\u00A0",
                                                                area.txNombreArea)
                                                            : React.createElement(React.Fragment, null);
                                                    })),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Categor\u00EDa:"),
                                                    categoriaList.map(function (categoria) {
                                                        if (_this.state.dtoData.idCategoria == categoria.idCategoria)
                                                            return React.createElement("strong", { key: categoria.idCategoria, className: "valor" },
                                                                " \u00A0\u00A0",
                                                                categoria.txNombreCategoria);
                                                    })),
                                                this.state.dtoData.audiencias != null
                                                    ?
                                                        React.createElement(React.Fragment, null,
                                                            React.createElement("div", { className: "titulo-anuncio" }, "Audiencias Objetivo: "),
                                                            React.createElement("ul", null, this.state.audienciaList.map(function (aud) {
                                                                return _this.state.dtoData.audiencias.includes(aud.idAudiencia) ?
                                                                    React.createElement("li", null,
                                                                        React.createElement("strong", { className: "valor" }, aud.txNombre))
                                                                    : React.createElement(React.Fragment, null);
                                                            })))
                                                    : React.createElement(React.Fragment, null),
                                                this.state.dtoData.txUrl == null ? null : React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Enlace:"),
                                                    " ",
                                                    React.createElement("a", { href: this.state.dtoData.txUrl, target: "_blank" },
                                                        " ",
                                                        React.createElement("strong", null,
                                                            "\u00A0\u00A0",
                                                            this.state.dtoData.txUrl.length > 60 ? React.createElement(React.Fragment, null, this.state.dtoData.txUrl.substring(0, 60) + "...") : React.createElement(React.Fragment, null, "" + this.state.dtoData.txUrl.substring(0, 60))))),
                                                this.state.dtoData.txLugar == null ? null : React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Lugar:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.txLugar)),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "\u00C1mbito:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.bdAmbito == "A" ? "Abierto" : "Interno")),
                                                this.state.dtoData.dtPublicacion == null ? null : React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Fecha Publicaci\u00F3n:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.dtPublicacion.split("T")[0])),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Publicaci\u00F3n Autom\u00E1tica:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.bdPublicarAutomatico ? "Sí" : "No")),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Comunicado Reiterativo:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.bdIsReiterativo ? "Sí" : "No")),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("div", { className: "titulo-anuncio" }, "Vigencia:"),
                                                    " ",
                                                    React.createElement("strong", { className: "valor" },
                                                        "\u00A0\u00A0",
                                                        this.state.dtoData.dtVigencia == null ? null : this.state.dtoData.dtVigencia.split("T")[0])),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("button", { className: "btn-info btn-round", onClick: function () { return _this.handleHistory(_this.state.dtoData.idAnuncio); } }, "Ver Historial Estado")),
                                                React.createElement("div", { className: "form-group row" },
                                                    React.createElement("button", { className: "btn-success btn-round", onClick: function () { return _this.handleEdit(_this.state.dtoData.idAnuncio); } }, "Editar")))))),
                                React.createElement("button", { hidden: true, onClick: this.toTop }, "to top"))))))));
    };
    return VerComunicado;
}(React.Component));
exports.VerComunicado = VerComunicado;
//# sourceMappingURL=VerComunicado.js.map